import { getFlightProgress } from "./getFlightProgress";
import flightCSS from "./FlightBar.module.css"; // Optional: for styling
import { Airplane } from "phosphor-react";

const FlightBar = ({ flight }) => {
  const { departureCountry, arrivalCountry, departureTime, arrivalTime } = flight;

  const progress = getFlightProgress(new Date(departureTime), new Date(arrivalTime));
  const percentage = `${progress * 100}%`;
    
  return (
    <div className={flightCSS.flightbarContainer}>
        <img
            src={`https://flagcdn.com/h40/${departureCountry.toLowerCase()}.png`}
            alt={departureCountry}
            style={{ height: "2.777vh", borderRadius: "4px", zIndex: "-10" }}
        />

        <div className={flightCSS.flightbarTrack}>
            <div className={flightCSS.flightbarTrail} style={{ width: percentage }} />
            <div className={flightCSS.flightbarProgress} style={{ left: percentage }}>
                <Airplane weight="fill" style={{transform: "rotate(90deg)"}}/>
            </div>
        </div>
        <img
            src={`https://flagcdn.com/h40/${arrivalCountry.toLowerCase()}.png`}
            alt={departureCountry}
            style={{ height: "2.777vh", borderRadius: "4px", zIndex: "-10" }}
        />

    </div>
  );
};

export { FlightBar };
